import { useCallback, useEffect, useState } from "react";
import { propiedadesApi, Bodeguita } from "../../services/propiedades.api";

export type BodeguitaForm = {
  bodeguita: string;
  id_propiedad: number;
};

export type PropertyOption = {
  id: number;
  nombrepropiedad: string;
};

export function useBodeguitasLogic() {
  const [bodeguitas, setBodeguitas] = useState<Bodeguita[]>([]);
  const [propiedades, setPropiedades] = useState<PropertyOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState<Bodeguita | null>(null);

  const fetchBodeguitas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await propiedadesApi.getBodeguitas();
      if (res?.data) setBodeguitas(res.data);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPropiedades = useCallback(async () => {
    const res = await propiedadesApi.getAll({ limit: 200 });
    if (res?.data) {
      setPropiedades(
        res.data.map((p: any) => ({
          id: p.id,
          nombrepropiedad: p.nombrepropiedad ?? p.nombrePropiedad ?? "",
        })),
      );
    }
  }, []);

  useEffect(() => {
    fetchBodeguitas();
    fetchPropiedades();
  }, [fetchBodeguitas, fetchPropiedades]);

  const openCreate = useCallback(() => {
    setEditing(null);
    setModalOpen(true);
  }, []);

  const openEdit = useCallback((record: Bodeguita) => {
    setEditing(record);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setEditing(null);
  }, []);

  const save = useCallback(
    async (values: BodeguitaForm) => {
      if (editing) {
        await propiedadesApi.updateBodeguita(editing.id, values);
      } else {
        await propiedadesApi.createBodeguita(values);
      }
      closeModal();
      await fetchBodeguitas();
    },
    [editing, closeModal, fetchBodeguitas],
  );

  const remove = useCallback(
    async (id: number) => {
      await propiedadesApi.deleteBodeguita(id);
      await fetchBodeguitas();
    },
    [fetchBodeguitas],
  );

  return {
    bodeguitas,
    propiedades,
    loading,
    modalOpen,
    editing,
    openCreate,
    openEdit,
    closeModal,
    save,
    remove,
    refresh: fetchBodeguitas,
  };
}
